var map = {
	"./black-bar.svg": "83c2",
	"./bullet.svg": "bd82",
	"./business-intelligence-big-data.jpg": "5d98",
	"./business-intelligence-big-data.webp": "663a",
	"./close.svg": "b857",
	"./gateway-and-embedded.jpg": "2b5c",
	"./gateway-and-embedded.webp": "413f",
	"./gateway.svg": "6026",
	"./hybrid-cloud-inf.jpg": "ad9c",
	"./hybrid-cloud-inf.webp": "bcd0",
	"./hybrid-cloud.svg": "7f3b",
	"./iot-management.svg": "e761",
	"./istock-907916910.jpg": "41d1",
	"./istock-907916910.webp": "80a3",
	"./machine-learning.svg": "9ff0",
	"./micro-datacenter.svg": "88c5",
	"./network.svg": "c9a9",
	"./pulse-iot-center.jpg": "9003b",
	"./pulse-iot-center.png": "5642",
	"./pulse-iot-center.webp": "e5bc",
	"./pulse-iot-center_001.webp": "7679",
	"./pulse.png": "f4c6",
	"./sample-img.jpg": "202f",
	"./sample-img.webp": "68a2",
	"./sensors-actuators.png": "a59a",
	"./sensors-and-actuators.jpg": "2f5a",
	"./sensors-and-actuators.webp": "a09d",
	"./vmware-digitalfoundation.jpg": "1f03",
	"./vmware-digitalfoundation.webp": "e82c",
	"./vmware-pulse-iot-center.jpg": "f15e",
	"./vmware-pulse-iot-center.webp": "5067"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e626";